// SPDX-License-Identifier: AGPL-3.0-or-later

import {ChannelTypes} from '@fluxer/constants/src/ChannelConstants';
import {isVoiceRoomTheme, type VoiceRoomTheme} from '@fluxer/constants/src/VoiceRoomThemes';

// Null/absent or retired guild voice overrides inherit; explicit 'none' remains flat, including on older clients.
export function effectiveRoomTheme(
	channelTheme: string | null | undefined,
	defaultTheme: string | null | undefined,
	channelType: number,
): VoiceRoomTheme | null {
	if (isVoiceRoomTheme(channelTheme)) return channelTheme;
	if (channelTheme === 'none' || channelType !== ChannelTypes.GUILD_VOICE) return null;
	return isVoiceRoomTheme(defaultTheme) ? defaultTheme : null;
}
